






















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({
  name: "cascade",
})
export default class Cascade extends Vue {
  private options: Array<any> = [
    {
      value: "浙江省",
      label: "浙江省",
      children: [
        {
          value: "杭州市",
          label: "杭州市",
          children: [
            {
              value: "临平区",
              label: "临平区",
            },
            {
              value: "萧山区",
              label: "萧山区",
            },
          ],
        },
        {
          value: "金华市",
          label: "金华市",
          children: [
            {
              value: "义乌市",
              label: "义乌市",
            },
          ],
        },
      ],
    },
    {
      value: "江西省",
      label: "江西省",
      children: [
        {
          value: "南昌市",
          label: "南昌市",
          children: [
            {
              value: "东湖区",
              label: "东湖区",
            },
          ],
        },
      ],
    },
    {
      value: "河南省",
      label: "河南省",
      children: [
        {
          value: "平顶山市",
          label: "平顶山市",
          children: [
            {
              value: "卫东区",
              label: "卫东区",
            },
          ],
        },
      ],
    },
  ];
  private zItem!: any;
  @Prop({ type: Number, default: 0 }) zIndex!: number;
  @Watch("zIndex", { immediate: true })
  // eslint-disable-next-line
  watchIndex() {}
  @Prop({ type: Object, default: {} })
  item!: any;
  @Watch("item", { immediate: true, deep: true })
  dataChage(value: any) {
    this.zItem = value;
  }
}
